// ==============================|| MENU ITEMS - SEPARATOR ||============================== //

// Empty separator menu item to visually separate sections in the navigation
const separator = {
  id: 'separator',
  title: '',
  type: 'divider'
};

export default separator;

